import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

type WarningVariant = "warning" | "notice";

interface WarningBoxProps {
  title?: string;
  children: React.ReactNode;
  boxVariant?: WarningVariant;
}

const WarningContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "boxVariant",
})<{ boxVariant: WarningVariant }>(({ boxVariant }) => ({
  backgroundColor: "#F8F9F9",
  borderRadius: "8px",
  padding: "12px 16px",
  textAlign: "left",
  "@media (min-width: 768px)": {
    padding: "16px 24px",
  },
}));

const WarningContent = styled(Typography)({
  fontFamily: "Roobert",
  fontSize: "13px",
  lineHeight: "1.5",
  color: "#374151",
  "@media (min-width: 768px)": {
    fontSize: "14px",
  },
});

export const WarningBox: React.FC<WarningBoxProps> = ({
  title,
  children,
  boxVariant = "warning",
}) => {
  return (
    <WarningContainer boxVariant={boxVariant}>
      <WarningContent>
        {title && <strong>{title}: </strong>}
        {children}
      </WarningContent>
    </WarningContainer>
  );
};

export default WarningBox;
